module.exports = __webpack_public_path__ + "img/slider_6.b587782a.jpg";